export function SimpleParallax() {
    const image = document.getElementsByClassName('parallax');
    new simpleParallax(image);
}
